export const clusterToEnv = (cluster: string) => {
  switch (cluster) {
    case 'euprod':
    case 'eusandbox':
    case 'staging':
      return 'eu';
    case 'usprod':
    case 'wip':
    case 'ussandbox':
      return 'us';
    default:
      return undefined; // Default case if none of the above cases match
  }
};
